var exports = {
  "hS": "PerformancePaneItemBox__g5xikQ",
  "NN": "PerformancePaneItemText__8cLXSc",
  "LE": "PerformancePaneItemCopyToClipboardIconButton__XtIOLl",
  "Lj": "PerformancePaneItemDetailsContainer__r1a6Uk",
  "v": "PerformancePaneItemName__t6pRv5",
  "v$": "PerformancePaneItemClusterCount__FMyI6V",
};

module.exports = exports;
